var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box no-margin" },
    [
      _c("div", { staticClass: "box-header" }, [
        _c("h3", { staticClass: "box-title" }, [
          _c("span", [_vm._v(_vm._s(_vm.t("menu.help_videos")))]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "box-body clearfix" }, [
        _c(
          "ul",
          { staticClass: "no-bullet" },
          _vm._l(_vm.videos, function (video) {
            return _c("li", [
              _c(
                "a",
                {
                  staticClass: "text-large videoLink",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      return _vm.showVideo(video)
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-video-camera text-black fa-fw",
                  }),
                  _vm._v("\n          " + _vm._s(video.title) + "\n        "),
                ]
              ),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.showLoadingModal
        ? _c(
            "Modal",
            {
              attrs: { size: "medium", "show-close-button": true },
              on: {
                close: function ($event) {
                  _vm.showLoadingModal = false
                },
              },
            },
            [
              _c("h3", [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _c("video", {
                attrs: {
                  id: "player",
                  autoplay: "true",
                  controls: "",
                  src: _vm.url,
                },
              }),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }